import { useState, useEffect } from "react";
import { connect } from 'react-redux';
import { useNavigate } from "react-router-dom";

import {
    Box,
    Skeleton,
} from '@mui/material';

import { GetSignUpInitialDetail, SetUserDetails } from "../../../redux/v2/user/actions";
import CustomButton from "../../../common/CustomButton";

const CompanySignup = (props) => {

    const [userData, setUserData] = useState(null);
    const [isTokenExpired, setIsTokenExpired] = useState(false);

    const navigate = useNavigate();

    useEffect(async () => {
        const userData = props.userData ? props.userData : await props.GetSignUpInitialDetail(props.token);
        if (userData === "token expired") {
            setIsTokenExpired(true);
        } else {
            props.SetUserDetails(userData);
            setUserData(userData)
            localStorage.setItem(props.token + "", JSON.stringify(userData));
        }
    }, []);


    return userData ? (
        <Box className="auth-box">
            <Box className="auth-box">
                <div className="container">
                    <div className="auth-form" style={{ padding: "0 30px", marginTop: "30px" }}>
                        <Box sx={{ mt: '30px' }}>
                            <h1 className="title-txt text-md-left indi-font-family title-text-center">Welcome, {userData.first_name}!</h1>
                        </Box>

                        <h5>Let's get moving and setup your account.</h5>

                        <Box>

                            <Box mt="40px">
                                <CustomButton onClick={() => navigate('/signup/email?token=' + props.token)}>
                                    Complete Sign Up
                                </CustomButton>
                            </Box>

                        </Box>

                    </div>
                </div>
            </Box>
        </Box>
    ) : (
        !isTokenExpired
            ? <Box className="auth-box">
                <Box className="auth-box">
                    <div className="container">
                        <img src="/assets/images/logo.png" alt="Indi" height={"40px"} />
                        <div className=" auth-form">
                            <Box sx={{ mt: '40px' }}>
                                <Skeleton variant="rectangle" height="3rem" width="100%" animation="pulse" sx={{ borderRadius: '10px' }} />
                            </Box>
                            <Box sx={{ mt: { xs: '30px', md: '30px' } }}>
                                <Skeleton variant="rectangle" height="2rem" width="100%" animation="pulse" sx={{ borderRadius: '10px' }} />
                            </Box>

                            <Box sx={{ mt: { xs: '30px', md: '30px' } }}>
                                <Skeleton variant="rectangle" height="2rem" width="100%" animation="pulse" sx={{ borderRadius: '10px' }} />
                            </Box>

                            <Box sx={{ mt: { xs: '30px', md: '30px' } }}>
                                <Box sx={{ m: 'auto' }}>
                                    <Skeleton variant="rectangle" height="4rem" width="100%" animation="pulse" sx={{ borderRadius: '10px' }} />
                                </Box>
                            </Box>

                        </div>
                    </div>
                </Box>
            </Box>
            : <Box className="auth-box">
                <Box className="auth-box">
                    <div className="container">
                        <img src="/assets/images/logo.png" alt="Indi" height={"40px"} />
                        <div className=" auth-form">

                            <Box sx={{ mt: { xs: '30px', md: '30px' } }}>
                                <p className="indi-font-family e-text">The username and password have already been set for this user.</p>
                            </Box>

                            <Box sx={{ mt: { xs: '30px', md: '30px' } }}>
                                <p className="indi-font-family e-text">Use the button below and your company email to reset your password.</p>
                            </Box>

                            <Box className="login-btn-wrapper">

                                <Box sx={{ m: 'auto' }}>
                                    <button id="action-button-dark" className="signup" onClick={() => navigate('/reset-password')}>
                                        Reset Password
                                    </button>
                                </Box>

                            </Box>

                        </div>
                    </div>
                </Box>
            </Box>
    );

};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, {
    GetSignUpInitialDetail,
    SetUserDetails,
})(CompanySignup);
